import { rdRequests, authorizedRDRequests } from "../httpRequest";

const membershipApiRequests = {
  loadMembershipData: () => authorizedRDRequests.post(`WebAccessMembership/Load/MembershipDetails`, {}),
  getSelectedMembershipDetails: (membershipParameters: any) => authorizedRDRequests.post(`WebAccessMembership/SelectedMembershipDetails`, membershipParameters),
  validateMembershipCartDetails: (membershipParameters: any) => authorizedRDRequests.post(`WebAccessMembership/ValidateMembershipCartDetails`, membershipParameters),
  validateMembershipMultiUserRestrictions: (multiMembershipParameters: any) => rdRequests.post(`WebAccessMembership/ValidateMembershipMultiUserRestrictions`, multiMembershipParameters)
}

export default membershipApiRequests;